import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC } from "react";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const DeleteTransactionalMailAliasModal: FC<{ domain: MailDomain, aliasDomain: string }> = ({ domain, aliasDomain }) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const reload = useRefresh()

  const confirm = async () => {
    const deployment = await partnerClient.deleteAliasFromTransactionalMailDomain(domain.id, aliasDomain).then(result => {
      if (!result.success) {
        throw new Error(result.error)
      }
      return result.data
    })
    await awaitNextDeploymentFinished(deployment.id)
    reload()
  }
  return <>
    <p className={""}>
      <strong>Caution!</strong> You are about to delete the alias domain <strong>{aliasDomain}</strong> from this domain.
    </p>
    <ModalFooter icon={faTrash} text={"Delete"} onSubmit={confirm} />
  </>
}
